export const ROUTES = {
  SIGNUP: '/signup',
  VERIFY_EMAIL: '/verify-email',
  CONTACTS: '/',
  PROFILE: '/profile',
  SIGNIN: '/signin',
  SIGNOUT: '/signout',
};
